import React from 'react';
import { FormattedMessage } from 'react-intl';

const translate = (id) => <FormattedMessage id={id}/>;

export default translate;